import React, { useContext, useState } from "react";
import Switch from "react-switch";
import { useLocation } from "react-router-dom";

//internal import
import { SidebarContext } from "context/SidebarContext";
import ConfirmActiveModal from "components/form/ConfirmActiveModal";
import AdminServices from "services/AdminServices";
import OfflineServices from "services/OfflineServices";
import { notifyError, notifySuccess } from "utils/toast";

const ShowHideButton = ({ id, status }) => {
  const location = useLocation();
  const { setIsUpdate } = useContext(SidebarContext);
  const [showActiveModal, setShowActiveModal] = useState(false);
  const [, setGoStatus] = useState();
  const handleChangeStatus = async (id) => {
    // return notifyError("CRUD operation is disabled for this option!");
    try {
      var newStatus;
      if (status === "Active") {
        newStatus = "Inactive";
        setGoStatus("Inactive");
      } else if (status === 1) {
        newStatus = 0;
        setGoStatus(0);
      } else if (status === 0) {
        newStatus = 1;
        setGoStatus(1);
      } else {
        newStatus = "Active";
        setGoStatus("Active");
      }


      if (location.pathname === "/vendor") {
        if (status !== undefined && status !== "") {
          setShowActiveModal(true);
        }
      }

      if (location.pathname === "/offlinequery") {
        
        const res = await OfflineServices.updateOfflineQuery(id, {
          is_solved: newStatus,
        });
        setIsUpdate(true);
        notifySuccess(res.message);
      }
      
      if (location.pathname === "/users") {
        const res = await AdminServices.updateStaffStatus(id, {
          status: newStatus,
        });
        setIsUpdate(true);
        notifySuccess(res.message);
      }
      if (location.pathname === "/agents") {
        setShowActiveModal(true);
        // setFunctionLoading(true);
        // const res = await AgentsServices.updateAgentsStatus(id, {
        //   status: newStatus,
        // });
        // setIsUpdate(true);
        // setFunctionLoading(false);
        // notifySuccess(res.message);
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };
 
  return (
    <>
      <Switch
        onChange={() => handleChangeStatus(id)}
        checked={status === "Active" || status === 1 ? true : false}
        className="react-switch md:ml-0"
        uncheckedIcon={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: "100%",
              width: 120,
              fontSize: 14,
              color: "white",
              paddingRight: 22,
              paddingTop: 1,
            }}
          ></div>
        }
        width={30}
        height={15}
        handleDiameter={13}
        offColor="#E53E3E"
        onColor={"#2F855A"}
        maxLength={200}
        checkedIcon={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: 73,
              height: "100%",
              fontSize: 14,
              color: "white",
              paddingLeft: 20,
              paddingTop: 1,
            }}
          ></div>
        }
      />
      <ConfirmActiveModal
        isOpen={showActiveModal}
        status={status}
        onClose={() => setShowActiveModal(false)}
      />
    </>
  );
};

export default ShowHideButton;
